/**
 * Dynamically import a component for a given name
 *
 * @param      {String}  componentName  The component name
 * @return     {Object}  A webpack dynamic import
 */
export function useGetComponentImportGraphQL(componentName) {
  return (componentType) => () => import(`~/components/Organisms/${componentName}${componentType}Graphql`);
}
